import React, { Component } from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {optionsAddedOrChanged} from "../../actions/OptionsActionsV2";
import {FormattedMessage} from "react-intl";
import Select, {SelectOption} from "@amzn/meridian/select";
import Text from "@amzn/meridian/text";
import {CPTAddedOrChanged} from "../../actions/OptionsActionsV2";
import {FEATURES} from "../../constants";

class FilterOptionsV2 extends Component {
    render() {

        const {allCycles, selectedCycle, allCPT, selectedCPT, CPTLabel} = this.props;
        if(!this.isCPTFilterEnabled()){
            return (
                <div>
                    <Text><FormattedMessage id="cycleOptions.cycle" defaultMessage="Cycle"/></Text>
                    <Select onChange={updatedCycle => this.handleCycleChange(updatedCycle, allCycles)} value={selectedCycle} placeholder={<FormattedMessage id="cycleOptions.cycle" defaultMessage="Cycle"/>}>
                        {allCycles.map(cycle => (
                            <SelectOption  key={cycle.cycleName}  value={cycle.cycleName} data-cy={"cycleFieldsetOption"} label={cycle.displayableName}/>
                        ))}
                    </Select>
                </div>
            )
        }
        else{
            return (
                <div>
                    <Text><FormattedMessage id={"CPT."+CPTLabel} defaultMessage="CPT"/></Text>
                    <Select onChange={updatedCPT => this.handleCPTChange(updatedCPT, allCPT)} value={selectedCPT}>
                        {allCPT.map(CPT => (
                            <SelectOption  key={CPT.id}  value={CPT.id} data-cy={"CPTFieldsetOption"} label={CPT.label}/>
                        ))}
                    </Select>
                </div>
            )
        }
    }

    isCPTFilterEnabled = () => {
        return this.props.featureStatus && this.props.featureStatus[FEATURES.IS_CPT_FILTER_ENABLED];
    }

    handleCycleChange(updatedCycle, allCycles) {
        this.props.dispatch(optionsAddedOrChanged(
            {
                'cycle': updatedCycle
            }));
        this.props.dispatch(optionsAddedOrChanged(
            {
                'cycleId': allCycles.filter(cycle => cycle.cycleId === updatedCycle).map(cycle => cycle.casCycleId)[0]
            }));
    }

    handleCPTChange(updatedCPT, allCPT) {
        this.props.dispatch(CPTAddedOrChanged(
            {
                'CPT': updatedCPT
            }))
        this.props.dispatch(CPTAddedOrChanged(
            {
                'CPTId': allCPT.filter(CPT => CPT.id === updatedCPT).map(CPT => CPT.id)[0]
            }))
    }
}

const mapStateToProps = state => ({
    selectedCycle: state.optionsReducerV2.options.cycle,
    allCycles: state.optionsReducerV2.allCycles,
    selectedCPT: state.optionsReducerV2.options.CPT,
    allCPT: state.optionsReducerV2.allCPT,
    featureStatus: state.configReducer.featureStatus,
    CPTLabel: state.optionsReducerV2.CPTLabel
});
export default withRouter(connect(mapStateToProps)(FilterOptionsV2));


// WEBPACK FOOTER //
// ./src/components/options/FilterOptionsV2.js